import type { ReactNode } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { Button } from "@similarweb/ui-components";

import { ConfirmationModal } from "app/pages/sales-intelligence/common-components/modals/ConfirmationModal/ConfirmationModal";
import {
    StyledConfirmationModalButtonsContainer,
    StyledConfirmationModalLabel,
} from "app/pages/sales-intelligence/common-components/modals/ConfirmationModal/styles";

type ConfirmButtonType = "primary" | "warning";

type EmployeeProfileConfirmationModalProps = {
    isOpen: boolean;
    titleKey: string;
    description: ReactNode;
    confirmLabel: string;
    confirmButtonType?: ConfirmButtonType;
    isLoading?: boolean;
    onCancel: () => void;
    onConfirm: () => void;
    dataAutomation: string;
};

export const EmployeeProfileConfirmationModal = ({
    isOpen,
    titleKey,
    description,
    confirmLabel,
    confirmButtonType = "primary",
    isLoading = false,
    onCancel,
    onConfirm,
    dataAutomation,
}: EmployeeProfileConfirmationModalProps) => {
    const { translate } = useTranslate();

    return (
        <ConfirmationModal
            isOpened={isOpen}
            titleKey={titleKey}
            dataAutomation={dataAutomation}
        >
            <StyledConfirmationModalLabel data-automation={`${dataAutomation}-description`}>
                {description}
            </StyledConfirmationModalLabel>
            <StyledConfirmationModalButtonsContainer>
                <Button
                    type={confirmButtonType === "warning" ? "flatDark" : "flat"}
                    onClick={onCancel}
                    isDisabled={isLoading}
                    dataAutomation={`${dataAutomation}-cancel`}
                >
                    {translate("si.common.button.cancel")}
                </Button>
                <Button
                    type={confirmButtonType}
                    onClick={onConfirm}
                    isDisabled={isLoading}
                    isLoading={isLoading}
                    dataAutomation={`${dataAutomation}-confirm`}
                >
                    {confirmLabel}
                </Button>
            </StyledConfirmationModalButtonsContainer>
        </ConfirmationModal>
    );
};
